import { Breadcrumb } from '@bphxd/ds-core-react';
import { Home24 } from '@bphxd/ds-core-react/lib/icons';
import { useParsedSearchParams, useSelectedAsset } from '../../lib/util';
import { Link, useLocation, useParams } from 'react-router-dom';
import { MAINTANENCE_PATH } from '../../constants';

const TabletBreadcrumbs = () => {
  const asset = useSelectedAsset();
  const location = useLocation();
  const params = useParams();
  const [certificateParam] = useParsedSearchParams('certificate');
  const certificate = certificateParam || location.state?.['search'];

  return (
    <Breadcrumb className="pt-4">
      <Breadcrumb.Item>
        <Link to={`/${MAINTANENCE_PATH}/certificates/search?asset=${asset?.assetName}`}>
          <Home24 />
        </Link>
      </Breadcrumb.Item>
      {certificate && (
        <Breadcrumb.Item>
          <Link to={`/${MAINTANENCE_PATH}/certificates/search?asset=${asset?.assetName}&certificate=${certificate}`}>
            Search Results
          </Link>
        </Breadcrumb.Item>
      )}
      {params['certificateId'] && (
        <Breadcrumb.Item>
          <Link
            to={`/${MAINTANENCE_PATH}/certificates/${params['certificateId']}/?asset=${asset?.assetName}`}
            state={location.state}
          >
            Certificate
          </Link>
        </Breadcrumb.Item>
      )}
      {params['jointId'] && (
        <Breadcrumb.Item>
          <Link
            to={`/${MAINTANENCE_PATH}/joints/${params['jointId']}/?asset=${asset?.assetName}`}
            state={location.state}
          >
            Joint
          </Link>
        </Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};

export default TabletBreadcrumbs;
